module.exports = __webpack_public_path__ + "img/pr-3.c82ade7b.png";